import React from 'react';
import ExploreLayout from '../components/ExploreLayout';
import ExploreCard from '../components/ExploreCard';
import useExplore from '../hooks/useExplore';

export default function ExploreBuildPage() {
  const { state, update } = useExplore();

  return (
    <ExploreLayout
      stepId="build"
      eyebrow="Build My Company"
      title="Turn the demo into their world."
      subtitle="For E1 this is still local and disposable. Later, this becomes the bridge from Explore to a real trial organization."
      nextLabel="Prepare launch"
    >
      <div className="explore-split">
        <div>
          <label className="explore-eyebrow" htmlFor="explore-company-name">Company name</label>
          <input
            id="explore-company-name"
            className="explore-input"
            value={state.companyName || ''}
            placeholder="Example: The Cape Kitchen"
            onChange={(event) => update({ companyName: event.target.value })}
          />
          <p className="explore-subtitle" style={{ fontSize: 16 }}>
            This will eventually personalize the demo company before automatic onboarding begins.
          </p>
        </div>
        <div className="explore-grid" style={{ gridTemplateColumns: '1fr' }}>
          <ExploreCard icon="🏢" title="Clone the closest demo world" description="Restaurant, retail, warehouse, hotel or security data becomes the starting point." />
          <ExploreCard icon="🧬" title="Replace demo details" description="Company name, logo, sites, staff, products and standards can become theirs step by step." />
          <ExploreCard icon="🔐" title="Launch only after intent" description="The public demo resets. A real organization is only created when the visitor chooses to continue." />
        </div>
      </div>
    </ExploreLayout>
  );
}
